<template>
    <div ref="frame" class="responsive-certificate-frame" :style="frameStyle">
        <div class="responsive-certificate-frame__canvas" :style="canvasStyle">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ResponsiveCertificateFrame',
    props: {
        designWidth: {
            type: Number,
            required: true
        },
        designHeight: {
            type: Number,
            required: true
        }
    },
    data() {
        const viewportWidth = typeof window === 'undefined' ? this.designWidth : window.innerWidth
        return {
            scale: Math.min(1, viewportWidth / this.designWidth),
            resizeObserver: null
        }
    },
    computed: {
        frameStyle() {
            return {
                maxWidth: this.designWidth + 'px',
                height: Math.round(this.designHeight * this.scale) + 'px'
            }
        },
        canvasStyle() {
            return {
                width: this.designWidth + 'px',
                height: this.designHeight + 'px',
                transform: 'scale(' + this.scale + ')'
            }
        }
    },
    mounted() {
        this.updateScale()
        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.updateScale)
            this.resizeObserver.observe(this.$refs.frame)
        } else {
            window.addEventListener('resize', this.updateScale)
        }
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
        } else {
            window.removeEventListener('resize', this.updateScale)
        }
    },
    methods: {
        updateScale() {
            const availableWidth = this.$refs.frame ? this.$refs.frame.clientWidth : 0
            if (availableWidth <= 0) return
            const nextScale = Math.min(1, availableWidth / this.designWidth)
            if (Math.abs(nextScale - this.scale) > 0.001) {
                this.scale = nextScale
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.responsive-certificate-frame {
    position: relative;
    width: 100%;
    margin: 0 auto 10px;
    overflow: hidden;

    &__canvas {
        position: absolute;
        top: 0;
        left: 0;
        transform-origin: top left;
    }
}
</style>
